import { select, put, takeLatest, all } from 'redux-saga/effects';
import { privateCall } from './api.saga';
import { appActions } from '../reducers/app.reducer';

function* boot() {
	try {
		const endpoint = yield select(s => s.config.endpoints.app.boot);
		const {
			isLoggedIn,
			token,
			user,
			profile,
			featureFlags,
			siteSettings,
			constants,
		} = yield privateCall({ endpoint, method: 'get' });

		if (!token)
			localStorage.clear();

		yield put(appActions.booted({ user, profile, token, featureFlags, isLoggedIn, constants, siteSettings }));
	} catch(e) {}
}

export default function* appSaga() {
	yield all([
		yield takeLatest(appActions.boot, boot),
	]);
}
